/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth, getuserinfo } from './views/modules/globalfunction'
import VueApexCharts from "vue3-apexcharts";



import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsExample from '@/components/DocsExample'
// import axios from 'axios'

//Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";


import VueHtmlToPaper from 'vue-html-to-paper';
import msalPlugin from './views/modules/msal'
import Swal from 'sweetalert2'
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    'http://localhost:8080/print.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: false, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}



library.add( fas, far, fab )

// Sweet Alert
// import Swal from 'sweetalert2'
// import 'sweetalert2/src/sweetalert2.scss'
// import VueSweetalert2 from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';
// import 'sweetalert2/src/sweetalert2.scss'



// import VueSweetalert2 from 'vue-sweetalert2';
// axios.defaults.baseURL = process.env.VUE_APP_API_URL
// axios.defaults.headers.common[ 'Authorization' ] = `Bearer ${ localStorage.getItem( "token" ) }`;
const app = createApp( App )
var retrievedUserData = localStorage.getItem( "users" );
  await msalPlugin.initialize();
await msalPlugin.handleRedirectPromise().then(async (response) => {

  if (response) {

    // First execute initialize
    const accessToken = response.accessToken;
    let email = response.account.username;
    localStorage.setItem('SSOToken', accessToken);
    localStorage.setItem('email', email);
    localStorage.setItem('Ok', true);
    // window.location.reload();
  
    await auth(accessToken, email);
    await getuserinfo(accessToken);


  }


}).catch((error) => {
  console.error('Error during login redirect:', error);

});


// app.provide('$axios', axios);

//Global Variables

if ( localStorage.getItem( "token" ) )
{
  app.config.globalProperties.globalAxiosConfig = {
    headers: {
      Authorization: `Bearer ${ localStorage.getItem( "BearerToken" ).replaceAll( '"', '' ) }`
    }
  };
  app.config.globalProperties.globalToken = `Bearer ${ localStorage.getItem( "BearerToken" ).replaceAll( '"', '' ) }`
}

const BearerToken = localStorage.getItem( 'BearerToken' )
// Global config with auth token

// console.log( "BearerToken =>", BearerToken )
app.config.globalProperties.globalConfig = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    'Authorization': 'Bearer ' + BearerToken,
  },
};


app.config.globalProperties.globalBearerToken = BearerToken;

app.use(msalPlugin);
app.use( VueAwesomePaginate )
app.use( store )
app.use( router )
app.use( CoreuiVue )
app.use( VueApexCharts );
app.use( VueHtmlToPaper, options );
app.use( VueHtmlToPaper );
app.provide( 'icons', icons )
app.component( 'CIcon', CIcon )
app.component( 'DocsExample', DocsExample )
app.component( 'font-awesome-icon', FontAwesomeIcon )

app.mount( '#app' )
